
import { Component, Vue } from "vue-property-decorator";
import { Toast } from "vant";
import { Service } from "src/decorator";
import { OrderService } from "src/services";
import dayjs from "dayjs";
import goods from "./sub/goods.vue";
import medical from "./sub/medical.vue";
import physical from "./sub/physical.vue";
import health from "./sub/health.vue";
import rights from "./sub/rights.vue";
import onlyBuy from "./sub/onlyBuy.vue";

@Component({
    components:
    {
        goods,
        medical,
        physical,
        health,
        rights,
        onlyBuy
    }
})
export default class OrderList extends Vue
{
    /**
     * 搜索关键字
     * @private
     * @returns string
     */
    private filters: any =
    {
        status: ""
    };

    /**
     * 加载
     */
    private loading:boolean = false
    /**
     * tab选中
     * @private
     * @returns number | string
     */
    private active: number | string = "";

    /**
     * 时间处理工具
     * @private
     * @returns dayjs
     */
    private dayjs: any = dayjs;

    /**
     * 订单列表
     * @private
     * @returns Array<any>
     */
    private orderList: Array<any> = [];

    /**
     * 获取当前登入信息
     * @private
     * @returns void
     */
    private get userInfo(): any
    {
        return this.$store.getters.userInfo || {};
    }

    /**
     * 订单状态
     * @private
     * @returns number
     */
    private get reserveType(): number
    {
        return +this.$route.query.type;
    }

    /**
     * 获取订单列表
     * @private
     * @returns void
     */
    private async getOrderList(): Promise<void>
    {
        try
        {
            let filters = Object.assign(this.filters);
            let { content: result } = await OrderService.instance.getOrderList(filters);
            if(result.data)
            {
                this.orderList = result.data || [];
            }
        }
        catch(err)
        {
            Toast(err);
        }
    }

    /**
     * 组件创建钩子
     * @private
     * @returns void
     */
    private created(): void
    {
        this.filters.status  = +this.reserveType;
        this.active  = +this.reserveType;
        this.getOrderList();
        
        window.addEventListener('pageshow', () => {
            this.filters.status  = +this.reserveType;
            this.active  = +this.reserveType;
            this.getOrderList();
            //外链回退到vue应用要执行的代码
        })
        
    }

    /**
     * tab切换
     * @private
     * @returns void
     */
    private onTabChange(type: any): void
    {
        this.filters.status = type;
        this.$router.push({name: "order-list", query: {type}});
        this.getOrderList();
    }

    /**
     * 刷新数据
     * @private
     * @returns void
     */
    private onRefresh(): void
    {
        setTimeout(() => {
            Toast('刷新成功');
        this.loading = false;
      }, 1000);

        this.getOrderList();
    }
}
